/**
 * Wrapper module around Bootstrap's accordion API 
 */


/**
 * 
 * @param {string} accordionSelector - the selector, id or class for the accordion element
 * @param {*} itemIndex - the index of the item in the accordion, 0-based
 * @returns {HTMLElement} - the 'collapse' element that bootstrap targets in it's accordion API 
 */
const getAccordionCollapse = (accordionSelector, itemIndex) => {
    const accordion = document.querySelector(accordionSelector);
    if (!accordion) return null;

    const items = accordion.querySelectorAll('.accordion-item');
    if (!items[itemIndex]) return null;

    return items[itemIndex].querySelector('.accordion-collapse');
}

/**
 * Opens an accordion item at a specified index, given the id/class of the accordion
 * @param {*} accordionSelector - the selector, id or class for the accordion element
 * @param {*} itemIndex - the index of the item in the accordion to open - 0-based
 * @returns {void}
 */
const openAccordionItem = (accordionSelector, itemIndex) => {
    const collapse = getAccordionCollapse(accordionSelector, itemIndex);
    if (!collapse) return;

    const instance =
        bootstrap.Collapse.getInstance(collapse) ||
        new bootstrap.Collapse(collapse, { toggle: false });

    instance.show();
}


/**
 * Closes an accordion item at a specified index, given the id/class of the accordion
 * @param {*} accordionSelector - the selector, id or class for the accordion element
 * @param {*} itemIndex - the index of the item in the accordion to close - 0-based
 * @returns {void}
 */
const closeAccordionItem = (accordionSelector, itemIndex) => {
    const collapse = getAccordionCollapse(accordionSelector, itemIndex);
    if (!collapse) return;

    const instance =
        bootstrap.Collapse.getInstance(collapse) ||
        new bootstrap.Collapse(collapse, { toggle: false });

    instance.hide();
}

/**
 * Closes all accordion items, given the id/class of the accordion
 * @param {*} accordionSelector - the selector, id or class for the accordion element
 * * @param {*} itemIndex - the index of the item in the accordion to open - 0-based
 */
const closeAllAccordionItems = (accordionSelector) => {
    const accordion = document.querySelector(accordionSelector);
    if (!accordion) return;

    accordion.querySelectorAll('.accordion-collapse.show').forEach(collapse => {
        const instance =
            bootstrap.Collapse.getInstance(collapse) ||
            new bootstrap.Collapse(collapse, { toggle: false });

        instance.hide();
    });
}

/**
 * Closes all accordion items but the one specified at itemIndex, given the id/class of the accordion
 * @param {*} accordionSelector - the selector, id or class for the accordion element
 */
const openAccordionItemExclusive = (accordionId, itemIndex) => {
    closeAllAccordionItems(accordionId);
    openAccordionItem(accordionId, itemIndex);
}


export {
    openAccordionItem,
    closeAccordionItem,
    openAccordionItemExclusive
}